/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MarketplaceLeadsLookupRequestApiModel } from '../../models/marketplace-leads-lookup-request-api-model';
import { MarketplaceSearchResponseApiModel } from '../../models/marketplace-search-response-api-model';

export interface SearchMarketplace$Params {
      body: MarketplaceLeadsLookupRequestApiModel
}

export function searchMarketplace(http: HttpClient, rootUrl: string, params: SearchMarketplace$Params, context?: HttpContext): Observable<StrictHttpResponse<MarketplaceSearchResponseApiModel>> {
  const rb = new RequestBuilder(rootUrl, searchMarketplace.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MarketplaceSearchResponseApiModel>;
    })
  );
}

searchMarketplace.PATH = '/marketplace/search';
